<template>
  <span v-if="displayText || $slots.default" data-testid="chip" :class="chipClasses">
    <slot>{{ displayText }}</slot>
  </span>
</template>

<script>
const BASE_CLASSES = 'inline-block uppercase font-manrope font-bold tracking-widest leading-none whitespace-nowrap'

const SIZE_CLASSES = {
  sm: 'text-xxs',
  md: 'text-625/100rem'
}

const VARIANT_CLASSES = {
  allergen: 'bg-brand-100 text-brand-600 px-2 py-1 rounded-sm',
  required: 'bg-brand-100 text-brand-600 px-2.5 py-1 rounded-full',
  // Fixed red rather than brand: an error has to read as one whatever hue the store is themed in.
  error: 'bg-red-600 text-white px-2.5 py-1 rounded-full',
  neutral: 'bg-gray-brand-200 text-gray-brand-700 px-2 py-1 rounded-sm'
}

export default {
  name: 'Chip',

  props: {
    label: {
      type: String,
      default: ''
    },
    text: {
      type: String,
      default: ''
    },
    size: {
      type: String,
      default: 'sm',
      validator: (value) => Object.keys(SIZE_CLASSES).includes(value)
    },
    variant: {
      type: String,
      default: 'allergen',
      validator: (value) => Object.keys(VARIANT_CLASSES).includes(value)
    }
  },

  computed: {
    displayText() {
      return (this.label || this.text || '').trim()
    },

    chipClasses() {
      return [
        BASE_CLASSES,
        SIZE_CLASSES[this.size] || SIZE_CLASSES.sm,
        VARIANT_CLASSES[this.variant] || VARIANT_CLASSES.allergen
      ]
    }
  }
}
</script>
